'use es6';

export const isNotNull = e => e !== null;